export default "__VITE_ASSET__0b399316__"